<template>
  <BaseLayout>
    <div
      class="fixed-center-top"
      style="min-width: 600px; max-width: 1000px; width: 40%"
    >
      <div class="row justify-center q-pa-md top">
        <img :src="$t('app.logo')" style="max-height: 40px" class="q-px-md" />
        <div class="text-h3">
          {{ $t("app.title") }}
        </div>
      </div>
      <slot />
      <div class="bottom">
        <div v-if="props.createAccount" class="row column items-center q-pa-md">
          <div class="text-bold">
            {{ $t("guest.new") }}
          </div>
          <div>
            <router-link id="create-account" :to="{ name: 'create-account' }">
              {{ $t("guest.create-account") }}
            </router-link>
          </div>
        </div>
        <div v-if="props.loginRedirect" class="row column items-center q-pa-md">
          <div class="text-bold">
            {{ $t("guest.existing-account") }}
          </div>
          <div>
            <router-link :to="{ name: 'login' }">
              {{ $t("guest.login") }}
            </router-link>
          </div>
        </div>
        <div v-if="props.onPremises" class="row column items-center q-pa-md">
          <div class="text-bold">
            {{ $t("guest.on-premises") }}
          </div>
          <div>
            <a target="_blank" :href="$t('links.on-premises.url')">
              {{ $t("guest.setup-yourself") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script setup lang="ts">
import BaseLayout from "~/BaseLayout.vue";

export interface Props {
  onPremises?: boolean;
  loginRedirect?: boolean;
  createAccount?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  onPremises: false,
  loginRedirect: false,
  createAccount: false,
});
</script>

<style>
.top {
  position: absolute;
  bottom: 100%;
  right: 50%;
  transform: translate(50%, 0%);
}

.bottom {
  position: absolute;
  top: 100%;
  right: 50%;
  transform: translate(50%, 0%);
}
</style>
